<template>
  <div :class="$style.editQuantity">
    <button v-if="!disabled"
            :class="$style.editQuantityBtn"
            @click.stop="decrease">
      <svg v-svg
           :class="$style.editQuantityIcon"
           symbol="minus-sign"/>
    </button>
    <span>{{ quantity }}</span>
    <button v-if="!disabled"
            :class="$style.editQuantityBtn"
            :disabled="increaseDisabled"
            @click.stop="increase">
      <svg v-svg
           :class="$style.editQuantityIcon"
           symbol="plus-sign"/>
    </button>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Quantity picker component.
 */
@Component({
  name:  'QuantityPicker',
  props: {
    quantity: {
      type:     Number,
      required: true,
    },
    minimum: {
      type:     Number,
      default:  0,
      required: false,
    },
    maximum: {
      type:     Number,
      default:  Infinity,
      required: false,
    },
    disabled: {
      type:     Boolean,
      required: false,
      default:  false,
    },
  },
})
export default class QuantityPicker extends Vue {
  /**
   * Default max limit.
   * @type {Number}.
   */
  defaultMaxLimit = 9;

  /**
   * Disabled increase button.
   * @return {boolean}
   */
  get increaseDisabled() {
    const maximum = this.maximum === null ? this.defaultMaxLimit : this.maximum;

    return this.disabled || this.quantity >= maximum;
  }

  increase() {
    if (this.maximum !== null && this.maximum === this.quantity) {
      return;
    }
    this.$emit('increaseQuantity');
    this.$emit('change-quantity', this.quantity + 1);
  }

  decrease() {
    if (this.minimum !== null && this.minimum === this.quantity) {
      return;
    }
    this.$emit('decreaseQuantity');
    this.$emit('change-quantity', this.quantity - 1);
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";

$edit-button-color: #DBDBDB;

.editQuantity {
  display: flex;
  align-items: center;

  .editQuantityBtn {
    width: 29px;
    height: 29px;
    border: 1px solid $edit-button-color;
    border-radius: 50%;
    outline: none;

    &:disabled {
      opacity: .3;
      background-color: $gray-light;
    }
  }

  span {
    padding: 0 5px;
    font-family: 'Gotham', sans-serif;
    font-size: 15px;
    font-weight: 300;
  }
}

.editQuantityIcon {
  width: 10px;
  height: 10px;
}

@media screen and (max-width: $kiosk-breakpoint-max) {
  .editQuantity .editQuantityBtn {
    width: 51px;
    height: 51px;
    border: 4px solid $edit-button-color;
  }

  .editQuantity span {
    font-size: 34px;
    line-height: 48px;
    padding: 0 26px;
  }

  .editQuantityIcon {
    width: 20px;
    height: 20px;
  }
}

@media screen and (max-width: $mobile-breakpoint-max) {
  .editQuantity {
    .editQuantityBtn {
      width: 29px;
      height: 29px;
      border: 1px solid $edit-button-color;
    }

    span {
      padding: 0 5px;
      font-size: 15px;
      line-height: 20px;
    }
  }
  .editQuantityIcon {
    width: 10px;
    height: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuantityPicker.vue